import { NormalizedStudentProfile, StudentProfile } from "./types";

function roundToTwo(value: number): number {
  return Math.round(value * 100) / 100;
}

export function deriveOsapProfile(
  profile: StudentProfile
): NormalizedStudentProfile {
  const isIndependent =
    profile.yearsOutOfHighSchool >= 6 ||
    profile.worked24MonthsInARow ||
    profile.status === "married" ||
    profile.status === "common_law" ||
    profile.status === "sole_support_parent";

  const parentInfoRequired = !isIndependent && profile.status === "single";

  const spouseInfoRequired =
    profile.status === "married" || profile.status === "common_law";

  const combinedParentIncome =
    (profile.parents.parent1Income ?? 0) +
    (profile.parents.parent2Income ?? 0);

  const combinedSpouseIncome =
    (profile.spouse.spouseIncome ?? 0) +
    (profile.spouse.spouseGovernmentIncome ?? 0);

  const totalDependantCount =
    profile.dependants.age0To11 +
    profile.dependants.age12PlusNoDisability +
    profile.dependants.age12PlusWithDisability;

  // Convert study weeks to months (used for living cost calculations)
  const studyMonths = roundToTwo(profile.study.studyWeeks / 4.345);

  return {
    ...profile,
    derived: {
      studyMonths,
      parentInfoRequired,
      spouseInfoRequired,
      combinedParentIncome,
      combinedSpouseIncome,
      totalDependantCount,
    },
  };
}